import {
  Box,
  RadioGroup,
  Stack,
  Image,
  Text,
  Button,
  useRadio,
  VStack,
  Flex,
  Divider,
  Radio,
  Input,
  Badge,

} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import SecondaryNav from "../../components/seconday-nav";
import MiniDropdownInput from "../../components/mini-dropdown";
import { PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { addUpdateSettings, getProfileforhome } from "../../middleware/services/profile";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { savePrescription, uploadImageCommonFunction, useScreenType } from "../../auth";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import MobileNavbar from "../../components/mobile-navbar";
import RichTextEditor from "../../components/rich-text-editor";


const PrescriptionTemplates = () => {
  const [selectedTemplate, setSelectedTemplate] = useState("1");
  const [unit, setUnit] = useState("cm");
  const [headerValue, setHeaderValue] = useState("");
  const [footerValue, setFooterValue] = useState("");
  // New mapping: use top/bottom/left/right fields for Custom Template (3)
  const [topValue, setTopValue] = useState("");
  const [bottomValue, setBottomValue] = useState("");
  const [leftValue, setLeftValue] = useState("");
  const [rightValue, setRightValue] = useState("");
  const [headerColor, setHeaderColor] = useState("");
  const [footerColor, setFooterColor] = useState("");
  const [verticalHeightValue, setVerticalHeightValue] = useState("");
  const [verticalWidthValue, setVerticalWidthValue] = useState("");
  const [errors, setErrors] = useState({ top: "", bottom: "", left: "", right: "" });
  const { showSuccessToast, showErrorToast } = Toaster();
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const screenType = useScreenType()
  const [headerHtml, setHeaderHtml] = useState('');
  const [footerHtml, setFooterHtml] = useState('');
  const [logofile, setLogoFile] = useState('');
  const validate = () => {
    const newErrors = { top: "", bottom: "", left: "", right: "" };
    let isValid = true;

    // Top/Bottom validation for templates that show them
    if (selectedTemplate !== "1" && (!topValue || isNaN(topValue))) {
      showErrorToast("Please enter a valid numeric top value");
      isValid = false;
    }

    if (selectedTemplate !== "1" && (!bottomValue || isNaN(bottomValue))) {
      showErrorToast("Please enter a valid numeric bottom value");
      isValid = false;
    }

    // Left/Right inputs validation only for Custom Template (3) when provided
    if (selectedTemplate === "3") {
      if (leftValue && isNaN(leftValue)) {
        showErrorToast("Please enter a valid numeric left value");
        isValid = false;
      }
      if (rightValue && isNaN(rightValue)) {
        showErrorToast("Please enter a valid numeric right value");
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const options = [
    {
      value: "1",
      image: "/assets/sample-prescription.png",
    },
    {
      value: "3",
      image: "/assets/sample-prescription-custom.png",
    },
    {
      value: "4",
      image: "/assets/sample-prescription-custom.png",
    },
  ];

  const handleUnitChange = (selectedOption) => {
    // console.log(selectedOption, "selectedOption")
    setUnit(selectedOption.value);
  };

   async function getDoctorProfile(){
    let inputData = {};
    try {
      const response = await getProfileforhome(inputData);
      if(response.ProfileOutput){
        savePrescription(response.ProfileOutput.templateid, response.ProfileOutput.templatevalue)
      }
    } catch (error) {
      console.log('error in fetching getDoctorProfile', error)
    }
  }

  const handleSave = async () => {
    if (!validate()) return;
    showLoader();
    let logourl = "";

    const isValidImage = (logofile) => {
        // Check if the file has an image extension (.png, .jpg, .jpeg)
        const validImageExtensions = /\.(png|jpg|jpeg)$/i;
        return validImageExtensions.test(logofile);
    };

    // Check if logofile is a valid image before uploading
    if (isValidImage(logofile)) {
        // If logofile is a valid image, skip upload and use the current logo (centerHeaderLogo)
        logourl = centerHeaderLogo;  // You can use the pre-existing logo if you want
    } else {
        // Otherwise, upload the logo and get the URL
        const result = await uploadImageCommonFunction(logofile, "logo");

        // Retrieve the image path from localStorage
        const jsonData = localStorage.getItem('LoginInfo');
        const data = JSON.parse(jsonData);
        const imagepath = data ? data.imagepath : null;

        // Construct the full image URL using the path and the uploaded result's name
        logourl = imagepath ? `${imagepath}${result.name}` : null;
    }

    const combinedHeaderHtml = `
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="flex: 1; text-align: left;">${leftHeaderHtml}</div>
        <div style="text-align: center;">
          ${centerHeaderLogo ? `<img src="${logourl}" alt="Logo" style="max-width: 100px;" />` : ""}
        </div>
        <div style="flex: 1; text-align: right;">${rightHeaderHtml}</div>
      </div>
    `;
    const input = {
      type:"template",
      templateid: selectedTemplate,
      templatevalue: {
        // Save top/bottom/left/right (and keep legacy keys for compatibility)
        top: selectedTemplate !== "1" ? (topValue + unit?.toLowerCase()) : "",
        bottom: selectedTemplate !== "1" ? (bottomValue + unit?.toLowerCase()) : "",
        left: selectedTemplate === '3' && leftValue ? (leftValue + unit?.toLowerCase()) : "",
        right: selectedTemplate === '3' && rightValue ? (rightValue + unit?.toLowerCase()) : "",
        // Legacy keys (kept for backward compatibility)
        header: selectedTemplate !== "1" ? (topValue + unit?.toLowerCase()) : "",
        footer: selectedTemplate !== "1" ? (bottomValue + unit?.toLowerCase()) : "",
        // verticalheight: selectedTemplate === '3' && leftValue ? (leftValue + unit?.toLowerCase()) : "",
        // verticalwidth: selectedTemplate === '3' && rightValue ? (rightValue + unit?.toLowerCase()) : "",
        headerHtml: (selectedTemplate === '4' || selectedTemplate === '5') ? (headerHtml ? headerHtml : combinedHeaderHtml) : "",
        footerHtml: (selectedTemplate === '4' || selectedTemplate === '5') ? footerHtml : "",
        headerColor: (selectedTemplate === '4' || selectedTemplate === '5') ? headerColor : "",
        footerColor: (selectedTemplate === '4' || selectedTemplate === '5') ? footerColor : "",
        leftHeader: (selectedTemplate === '4' || selectedTemplate === '5') ? leftHeaderHtml : "",
        rightHeader: (selectedTemplate === '4' || selectedTemplate === '5') ? rightHeaderHtml : "",
        logourl: (selectedTemplate === '4' || selectedTemplate === '5') ? logourl : "",
      },
    };
    try {
      const result = await addUpdateSettings(input)
      if(result.output.result === "success"){
        showSuccessToast("Template saved successfully!");
        getDoctorProfile()
      }
    } catch (error) {
      console.error("Error saving template:", error);
      showErrorToast("Failed to save template. Please try again.");
    } finally {
      dismissLoader();
    }
  };

  useEffect(() => {
    try {
      const savedPrescription = localStorage.getItem("prescriptionTemplate");
      if (savedPrescription) {
        const { templateId, templateValue } = JSON.parse(savedPrescription);

        if (templateId) {
          setSelectedTemplate(templateId.toString());
        }

        if (templateValue) {
          const extractNumber = (str) => {
            const match = str.match(/^(\d+(\.\d+)?)/);
            return match ? match[0] : "";
          };

          const extractUnit = (str) => {
            const match = str.match(/[a-zA-Z]+$/);
            return match ? match[0] : "cm";
          };

          // Map top/bottom/left/right (support legacy keys too)
          setTopValue(extractNumber(templateValue.top || templateValue.header || ""));
          setBottomValue(extractNumber(templateValue.bottom || templateValue.footer || ""));
          setHeaderColor(templateValue.headerColor || "");
          setFooterColor(templateValue.footerColor || "");
          setHeaderHtml(templateValue.headerHtml || "");
          setFooterHtml(templateValue.footerHtml || "");
          setRightHeaderHtml(templateValue.rightHeader || "");
          setLeftHeaderHtml(templateValue.leftHeader || "");
          setLogoFile(templateValue.logourl || "");
          setCenterHeaderLogo(templateValue.logourl || "");

          const headerUnit = extractUnit(templateValue.top || templateValue.header || "");
          const footerUnit = extractUnit(templateValue.bottom || templateValue.footer || "");
          const leftUnit = extractUnit(templateValue.left || templateValue.verticalheight || "");
          const rightUnit = extractUnit(templateValue.right || templateValue.verticalwidth || "");

          // prefer header/top unit, otherwise use left/right units if consistent
          if (headerUnit && headerUnit === footerUnit) {
            setUnit(headerUnit.toLowerCase());
          } else if (leftUnit && leftUnit === rightUnit) {
            setUnit(leftUnit.toLowerCase());
          }

          setLeftValue(extractNumber(templateValue.left || templateValue.verticalheight || ""));
          setRightValue(extractNumber(templateValue.right || templateValue.verticalwidth || ""));
        }
      }
    } catch (error) {
      console.error("Error loading prescription template from localStorage", error);
    }
  }, []);

  const gobackfunction = ()=>{
    window.history.back();
   }

  const handleHeaderChange = (content) => {
      setHeaderHtml(content);
  };
  
  const handleFooterChange = (content) => {
      setFooterHtml(content);
  };

  const [logo, setLogo] = useState(null); // state for the uploaded logo
  const [leftHeaderHtml, setLeftHeaderHtml] = useState(""); // Left header HTML state
  const [rightHeaderHtml, setRightHeaderHtml] = useState(""); // Right header HTML state
  const [centerHeaderLogo, setCenterHeaderLogo] = useState(null);
  // Handle Logo upload
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCenterHeaderLogo(URL.createObjectURL(file)); // Set the logo preview
      setLogoFile(file);
    }
  };

//Right Header
const handleLeftHeaderChange = (content) => {
  setLeftHeaderHtml(content);
};
//Left Header
  const handleRightHeaderChange = (content) => {
    setRightHeaderHtml(content);
  };
const cleanContent = (content) => {
  return content
    .replace(/<p[^>]*>/g, '<div>')  // open p → div
    .replace(/<\/p>/g, '</div>')    // close p → div
    .replace(/<br\s*\/?>/g, '<br>'); // keep <br> for enters
};
const safeleftHeader = cleanContent(leftHeaderHtml);
const saferightHeader = cleanContent(rightHeaderHtml);
const safeFooter = cleanContent(footerHtml);



  const handleuploadDocumentAttachment = () => {
    document.getElementById("uploaddocument").click();
  }
  return (
    <>
    {isLoading && <Loader />}
    {screenType !== "mobile" ? (
      <Box>
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          <Box w="calc(100vw - 6.5rem)">
            <SecondaryNav withBack="Prescription Templates" goBack={gobackfunction} />
            <Flex w="100%" h="calc(100vh - 75px)">
              <Box w="20%">
                <Box pos="relative" borderBottom="1px solid #E2E8F0" p="1rem">
                  <Text
                    textAlign="center"
                    fontWeight="600"
                    pos="sticky"
                    top="0"
                  >
                    Select your template
                  </Text>
                </Box>
                <Stack spacing={4} h='calc(100% - 70px)' justifyContent='space-between' p="1rem">
                <RadioGroup onChange={setSelectedTemplate} value={selectedTemplate || "1"} display='flex' flexDir='column' gap='0.875rem'>
                  {options.map(({ value }) => (
                    <Flex
                      key={value}
                      htmlFor={`template-${value}`}
                      w="100%"
                      as="label"
                      alignItems="center"
                      gap="0.5rem"
                      cursor="pointer"
                      p="0.5rem 1rem"
                      border="2px solid"
                      borderColor={selectedTemplate === value ? "#38A169" : "#e2e2e2"}
                      borderRadius="10px"
                      h="3rem"
                    >
                      <Radio value={value} id={`template-${value}`} colorScheme="green" />
                      <Text lineHeight='normal' fontSize={{base:'sm',md:'medium',lg:'larger'}}>{value === "1" ? "Default Template" : value === '4' ? 'Creative Template' : "Custom Template"}
                            {value === "3" && <Box as="span" fontSize='0.75rem' ml='0.35rem' fontWeight='600'>(No Header / Footer)</Box>}
                      </Text>
                    </Flex>
                  ))}
                </RadioGroup>
                {selectedTemplate == "1" && (
                  <Box w='100'>
                    <PrimaryButton
                      buttonText="Save Default"
                      onClick={handleSave} // make sure this calls the same logic
                      />
                  </Box>
                )}
                </Stack>
              </Box>
              <Divider orientation="vertical" h="auto" />
              <Box w="80%">
                {selectedTemplate === "3" ? (
                  <>
                    <Box w="100%" display='flex' gap='1rem' h="100%" my="auto">
                      <Box w='70%' m="1rem" ml='3rem'>
                        <Flex bg='#ededed' justifyContent='center' alignItems='center' w='100%' h='50px' mx='auto'>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            textAlign="center"
                            color={footerColor}
                          >
                            Placeholder for your Header
                          </Text>
                        </Flex>
                        <Image
                          src={
                            options.find((opt) => opt.value === selectedTemplate)
                              ?.image
                          }
                          alt="Selected Template"
                          // maxH="calc(100vh - 200px)"
                          borderRadius="md"
                          h='auto'
                          w='100%'
                          mx="auto"
                        />
                        <Flex bg='#ededed'justifyContent='center' alignItems='center' w='100%' h='50px' mx='auto'>
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            textAlign="center"
                            color={footerColor}
                          >
                            Placeholder for your Footer
                          </Text>
                        </Flex>
                      </Box>
                      <Flex w="100%" h="100%" align="center" justify="center">
                        <Box
                          w={{base: '90%', xl: '40%'}}
                          display="flex"
                          flexDir="column"
                          alignItems="center"
                          p="1rem"
                          borderRadius="12px"
                          border="1px solid #E2E2e2"
                          boxShadow="0px 8px 20px 0px #E6E7E966"
                        >
                          <Text
                            fontSize="0.875rem"
                            fontWeight="600"
                            textAlign="center"
                          >
                            Provide your Header and Footer length
                          </Text>

                          <VStack mt="1rem" gap="0" position="relative" zIndex="0" mb="1rem" w="100%" overflow="visible">
                            <Box pos='relative' zIndex='9' w='100%'>
                            <MiniDropdownInput
                              variant="defaultSide"
                              options={[
                                { label: "CM", value: "cm" },
                                { label: "PX", value: "px" },
                              ]}
                              placeholderProp="Top"
                              onSelect={handleUnitChange}
                              handleInputChange={(e) =>
                                setTopValue(e.target.value)
                              }
                              inputVal={topValue}
                              defaultOptionProp={unit}
                              />
                            </Box>

                            <Box pos='relative' zIndex='2' w='100%'>
                            <MiniDropdownInput
                              variant="downSide"
                              options={[
                                { label: "CM", value: "cm" },
                                { label: "PX", value: "px" },
                              ]}
                              placeholderProp="Bottom"
                              onSelect={handleUnitChange}
                              handleInputChange={(e) =>
                                setBottomValue(e.target.value)
                              }
                              inputVal={bottomValue}
                              defaultOptionProp={unit}
                              />
                            </Box>

                            {/* Left / Right inputs */}
                            <Box pos='relative' zIndex='2' w='100%'>
                              <MiniDropdownInput
                                variant="defaultSide"
                                options={[
                                  { label: "CM", value: "cm" },
                                  { label: "PX", value: "px" },
                                ]}
                                placeholderProp="Left"
                                onSelect={handleUnitChange}
                                handleInputChange={(e) => setLeftValue(e.target.value)}
                                inputVal={leftValue}
                                defaultOptionProp={unit}
                              />
                            </Box>

                            <Box pos='relative' zIndex='2' w='100%'>
                              <MiniDropdownInput
                                variant="downSide"
                                options={[
                                  { label: "CM", value: "cm" },
                                  { label: "PX", value: "px" },
                                ]}
                                placeholderProp="Right"
                                onSelect={handleUnitChange}
                                handleInputChange={(e) => setRightValue(e.target.value)}
                                inputVal={rightValue}
                                defaultOptionProp={unit}
                              />
                            </Box>

                            <PrimaryButton
                              mt="1rem"
                              buttonText="Save"
                              onClick={handleSave}
                            />
                          </VStack>
                        </Box>
                      </Flex>
                    </Box>
                  </>
                ) : selectedTemplate === '4' ? (
                  <>
                    <Box w="100%" display="flex" gap="1rem" h="100%" my="auto" overflow="auto">
                      {/* Left Section: Template Preview */}
                      <Box w="70%" m="1rem" ml="3rem">
                        {/* Header Section */}
                        <Flex
                          bg={headerColor ? headerColor : "#ededed"}
                          w="100%"
                          h={headerValue && unit ? headerValue+unit : '50px'}
                          pt={topValue && unit ? topValue+unit : '0.75rem'}
                          pb="0.75rem"
                          pl="0.75rem"
                          pr="0.75rem"
                          justifyContent={headerHtml ? 'flex-start' : 'center'}
                          align="center" // Centers the content vertically
                        >
                          {/* Left Section: Always left aligned */}
                         {leftHeaderHtml || rightHeaderHtml || centerHeaderLogo ? (
                          <>
                            {/* Left Section: Left aligned */}
                            <Box w="30%" display="flex" justifyContent="flex-start">
                              <Text fontSize="0.875rem" fontWeight="600">
                                <span dangerouslySetInnerHTML={{ __html: safeleftHeader }} />
                              </Text>
                            </Box>

                            {/* Center Section: Always center aligned */}
                            <Box w="40%" display="flex" justifyContent="center" alignItems="center">
                              {centerHeaderLogo && (
                                <Image src={centerHeaderLogo} alt="Logo" boxSize="50px" />
                              )}
                            </Box>

                            {/* Right Section: Always right aligned */}
                            <Box w="30%" display="flex" justifyContent="flex-end">
                              <Text fontSize="0.875rem" fontWeight="600">
                                <span dangerouslySetInnerHTML={{ __html: saferightHeader }} />
                              </Text>
                            </Box>
                          </>
                        ) : (
                          <Text fontSize="0.875rem" fontWeight="600" textAlign="center">
                            Start customizing your Header
                          </Text>
                        )}
                        </Flex>


                        {/* Template Image Preview */}
                        <Image
                          src={options.find((opt) => opt.value === selectedTemplate)?.image}
                          alt="Selected Template"
                          borderRadius="md"
                          h="auto"
                          w="100%"
                          mx="auto"
                        />

                        {/* Footer Section */}
                        <Flex
                          bg={footerColor ? footerColor : "#ededed"}
                          w="100%"
                          h={footerValue && unit ? footerValue+unit : '50px'}
                          pb={bottomValue && unit ? bottomValue+unit : '0.75rem'}
                          pt="0.75rem"
                          pl="0.75rem"
                          pr="0.75rem"
                          justifyContent={footerHtml ? 'flex-start' : 'center'}
                        >
                          {footerHtml ? 
                               <Text fontSize="0.875rem" fontWeight="600" w="100%" textAlign="center" >
                                  <span dangerouslySetInnerHTML={{ __html: safeFooter }} />
                                </Text>
                            : 
                            <Text
                              fontSize="0.875rem"
                              fontWeight="600"
                              textAlign="center"
                            >
                              Start customizing your Footer
                            </Text>
                            }
                         
                        </Flex>
                      </Box>

                      {/* Right Section: Editable Fields */}
                      <Flex w="100%" h="100%" align="center" justify="center">
                        <Box
                          w="100%"
                          marginTop="100px"
                          display="flex"
                          flexDir="column"
                          alignItems="center"
                          p="1rem"
                          border="1px solid #E2E2e2"
                          boxShadow="0px 8px 20px 0px #E6E7E966"
                        >
                          <VStack w="100%" spacing={4} align="stretch">
                            {/* Header Section */}
                            <Box>
                              <Text fontSize="0.875rem" fontWeight="600" textAlign="center" mb="0.5rem">
                                Provide your Header details
                              </Text>
                              <Flex w="100%" direction="column" align="center" justify="center" gap="1rem">
                                {/* Left Section: Editable */}
                                <Box w="100%" display="flex" flexDir="column" alignItems="flex-start">
                                  <Text fontSize="0.875rem" fontWeight="600" mb="0.5rem">Left Section</Text>
                                  <RichTextEditor onChange={handleLeftHeaderChange} value={leftHeaderHtml} />
                                </Box>

                                {/* Center Section: Logo Upload */}
                                <Box w="30%" display="flex" flexDir="column" alignItems="center">
                                  <Text fontSize="0.875rem" fontWeight="600" mb="0.5rem">Upload Logo</Text>
                                  <Input
                                    type="file"
                                    accept="image/*"
                                    id="uploaddocument"
                                    hidden
                                    onChange={handleLogoUpload}
                                  />    
                                  <Box
                                      as="button"
                                      flexDir="column"
                                      justifyContent="center"
                                      alignItems="center"
                                      w="calc(100% - 25%)"
                                      mx='auto'
                                      p="20px"
                                      gap="8px"
                                      border="1px dashed #CDCFD4"
                                      borderRadius="12px"
                                      onClick={handleuploadDocumentAttachment}
              
                                    >
                                      {/* <Image
                                        w="20px"
                                        m="auto"
                                        mb="10px"
                                        h="auto"
                                        src="/assets/svgs/file-upload.svg"
                                      /> */}
                                      <Text fontSize="14px" color="#163E9E" fontWeight="600">
                                        Drop your logo here
                                      </Text>
                                    </Box>                                        
                                  {/* <Input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleLogoUpload}
                                    marginBottom="1rem"
                                  /> */}
                                  {/* {centerHeaderLogo && <Image src={centerHeaderLogo} alt="Logo" boxSize="50px" />} */}
                                </Box>

                                {/* Right Section: Editable */}
                                <Box w="100%" display="flex" flexDir="column" alignItems="flex-end">
                                  <Text fontSize="0.875rem" fontWeight="600" mb="0.5rem">Right Section</Text>
                                  <RichTextEditor onChange={handleRightHeaderChange} value={rightHeaderHtml} />
                                </Box>
                              </Flex>
                              {/* Header Length and Color Picker */}
                              <Flex mt="0.5rem" gap="1rem" align="center">
                                <Box pos="relative" zIndex="9" w="40%">
                                 <MiniDropdownInput
                                    variant="fullSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Top"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setTopValue(e.target.value)
                                    }
                                    inputVal={topValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box flex="1">
                                  <Flex align="center">
                                    <Input
                                      p="0"
                                      id="header-color"
                                      type="color"
                                      value={headerColor}
                                      onChange={(e) => setHeaderColor(e.target.value)}
                                      w="12"
                                      h="12"
                                      cursor="pointer"
                                      border="none"
                                    />
                                    <Input
                                      value={headerColor}
                                      onChange={(e) => setHeaderColor(e.target.value)}
                                      placeholder="#000000"
                                      fontFamily="mono"
                                    />
                                  </Flex>
                                </Box>
                              </Flex>
                            </Box>

                            <Divider />

                            {/* Footer Section */}
                            <Box>
                              <Text fontSize="0.875rem" fontWeight="600" textAlign="center" mb="0.5rem">
                                Provide your Footer details
                              </Text>
                              <RichTextEditor onChange={handleFooterChange} value={footerHtml} />
                              <Flex mt="0.5rem" gap="1rem" align="center">
                                <Box pos='relative' zIndex='2' w='40%'>
                                  <MiniDropdownInput
                                    variant="fullSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Footer Length"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setFooterValue(e.target.value)
                                    }
                                    inputVal={footerValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box flex="1">
                                  <Flex align="center">
                                    <Input
                                      p="0"
                                      id="footer-color"
                                      type="color"
                                      border="none"
                                      value={footerColor}
                                      onChange={(e) => setFooterColor(e.target.value)}
                                      w="12"
                                      h="12"
                                      cursor="pointer"
                                    />
                                    <Input
                                      value={footerColor}
                                      onChange={(e) => setFooterColor(e.target.value)}
                                      placeholder="#000000"
                                      fontFamily="mono"
                                    />
                                  </Flex>
                                </Box>
                              </Flex>
                            </Box>

                            {/* Save Button */}
                            <PrimaryButton mt="1rem" buttonText="Save" onClick={handleSave} />
                          </VStack>
                        </Box>
                      </Flex>
                    </Box>
                  </>
                ) : (
                  <Image
                    src={
                      options.find((opt) => opt.value === selectedTemplate)
                        ?.image
                    }
                    alt="Selected Template"
                    maxH="calc(100vh - 100px)"
                    borderRadius="md"
                    mx="auto"
                    mt='1rem'
                  />
                )}
              </Box>
            </Flex>
          </Box>
        </Flex>
      </Box>

    ) : (
      <>
        <MobileNavbar />
        <MobileSecondaryNav
          header="Prescription Templates"
          handlebackarrow={true}
        />
      <Box p="1rem" h="calc(100vh - 200px)" overflow='hidden auto'>
        <Stack spacing="1.5rem">
          <RadioGroup onChange={setSelectedTemplate} display='flex'  gap='0.5rem' value={selectedTemplate || "1"}>
            {options.map(({ value }) => (
              <Flex
                key={value}
                as="label"
                alignItems="center"
                gap="0.5rem"
                p="0.5rem 1rem"
                border="2px solid"
                borderColor={selectedTemplate === value ? "#38A169" : "#e2e2e2"}
                borderRadius="10px"
              >
                <Radio value={value} colorScheme="green" />
                <Text fontSize='xs'>
                  {value === "1" ? "Default Template" : "Custom Template"}
                  {value === "3" && <Box as="span" fontSize='0.75rem' ml='0.5rem'>No Header / Footer</Box>}
                </Text>
              </Flex>
            ))}
          </RadioGroup>
          <Divider />
          {selectedTemplate === "3" ? (
            <>
              <Image
                src={options.find((opt) => opt.value === selectedTemplate)?.image}
                alt="Custom Template"
                borderRadius="md"
                w="100%"
              />
              <Box>
              <MiniDropdownInput
                variant="defaultSide"
                placeholderProp="Header Length"
                options={[
                  { label: "CM", value: "cm" },
                  { label: "PX", value: "px" },
                ]}
                onSelect={handleUnitChange}
                handleInputChange={(e) => setHeaderValue(e.target.value)}
                inputVal={headerValue}
                defaultOptionProp={unit}
              />
              <MiniDropdownInput
                variant="downSide"
                placeholderProp="Footer Length"
                options={[
                  { label: "CM", value: "cm" },
                  { label: "PX", value: "px" },
                ]}
                onSelect={handleUnitChange}
                handleInputChange={(e) => setFooterValue(e.target.value)}
                inputVal={footerValue}
                defaultOptionProp={unit}
              />
              <MiniDropdownInput
                variant="defaultSide"
                placeholderProp="Vertical Height"
                options={[
                  { label: "CM", value: "cm" },
                  { label: "PX", value: "px" },
                ]}
                onSelect={handleUnitChange}
                handleInputChange={(e) => setVerticalHeightValue(e.target.value)}
                inputVal={verticalHeightValue}
                defaultOptionProp={unit}
              />
              <MiniDropdownInput
                variant="downSide"
                placeholderProp="Vertical Width"
                options={[
                  { label: "CM", value: "cm" },
                  { label: "PX", value: "px" },
                ]}
                onSelect={handleUnitChange}
                handleInputChange={(e) => setVerticalWidthValue(e.target.value)}
                inputVal={verticalWidthValue}
                defaultOptionProp={unit}
              />
              </Box>
              <PrimaryButton buttonText="Save" onClick={handleSave} />
            </>
          ) : selectedTemplate === '4' ? (
                   <>
                    <Box w="100%" display='flex' justifyContent='center' flexDir='column' gap='1rem' h="100%" my="auto">
                      <Box w='100%'>
                        <Flex bg={headerColor ? headerColor : '#ededed'} w='100%' h={headerValue && unit ? headerValue+unit : '50px'} pt={topValue && unit ? topValue+unit : '0.75rem'} pb='0.75rem' pl='0.75rem' pr='0.75rem' justifyContent={headerHtml ? 'flex-start' : 'center'}>
                          
                            {headerHtml ? 
                              <div style={{width: '100%'}} dangerouslySetInnerHTML={{ __html: headerHtml }}/>
                            : 
                            <Text
                              fontSize="0.875rem"
                              fontWeight="600"
                              textAlign="center"
                            >
                              Start customizing your Header
                            </Text>
                            }
                        </Flex>
                        <Image
                          src={
                            options.find((opt) => opt.value === selectedTemplate)
                              ?.image
                          }
                          alt="Selected Template"
                          // maxH="calc(100vh - 200px)"
                          borderRadius="md"
                          h='auto'
                          w='100%'
                          mx="auto"
                        />
                        <Flex bg={footerColor ? footerColor : '#ededed'} w='100%' h={footerValue && unit ? footerValue+unit : '50px'} pb={bottomValue && unit ? bottomValue+unit : '0.75rem'} pt='0.75rem' pl='0.75rem' pr='0.75rem' justifyContent={footerHtml ? 'flex-start' : 'center'}>
                          {footerHtml ? 
                              <div style={{width: '100%'}} dangerouslySetInnerHTML={{ __html: footerHtml }}/>
                            : 
                            <Text
                              fontSize="0.875rem"
                              fontWeight="600"
                              textAlign="center"
                            >
                              Start customizing your Footer
                            </Text>
                            }
                          
                          
                        </Flex>
                      </Box>
                      <Flex w="100%" h="100%" align="center" justify="center">
                        <Box
                          w={{base: '90%', xl: '90%'}}
                          // h='100%'
                          // my='1rem'
                          display="flex"
                          flexDir="column"
                          alignItems="center"
                          p="1rem"
                          borderRadius="12px"
                          border="1px solid #E2E2e2"
                          boxShadow="0px 8px 20px 0px #E6E7E966"
                          justifyContent='center'
                        >
                          <VStack w="100%" spacing={4} align="stretch">
                            {/* Header Section */}
                            <Box>
                              <Text
                                fontSize="0.875rem"
                                fontWeight="600"
                                textAlign="center"
                                mb='0.5rem'
                              >
                               Provide your Header details
                              </Text>
                              <RichTextEditor onChange={handleHeaderChange} value={headerHtml} />
                              <Flex mt="0.5rem" gap="1rem" align="center">
                                <Box pos='relative' zIndex='9' w='40%'>
                                  <MiniDropdownInput
                                    variant="fullSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Header Length"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setHeaderValue(e.target.value)
                                    }
                                    inputVal={headerValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box pos='relative' zIndex='8' w='40%'>
                                  <MiniDropdownInput
                                    variant="downSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Top"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setTopValue(e.target.value)
                                    }
                                    inputVal={topValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box flex="1">
                                  <Flex align="center">
                                    <Input
                                      p='0'
                                      id="header-color"
                                      type="color"
                                      value={headerColor}
                                      onChange={(e) => setHeaderColor(e.target.value)}
                                      w="12"
                                      h="12"
                                      cursor="pointer"
                                      border='none'
                                    />
                                    <Input
                                      value={headerColor}
                                      onChange={(e) => setHeaderColor(e.target.value)}
                                      placeholder="#000000"
                                      fontFamily="mono"
                                    />
                                  </Flex>
                                </Box>
                              </Flex>
                            </Box>
                            <Divider />
                            {/* Footer Section */}
                            <Box>
                              <Text
                                fontSize="0.875rem"
                                fontWeight="600"
                                textAlign="center"
                                mb='0.5rem'
                              >
                                Provide your Footer details
                              </Text>
                              <RichTextEditor onChange={handleFooterChange} value={footerHtml} />
                              <Flex mt="0.5rem" gap="1rem" align="center">
                                <Box pos='relative' zIndex='2' w='40%'>
                                  <MiniDropdownInput
                                    variant="fullSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Footer Length"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setFooterValue(e.target.value)
                                    }
                                    inputVal={footerValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box pos='relative' zIndex='1' w='40%'>
                                  <MiniDropdownInput
                                    variant="downSide"
                                    options={[
                                      { label: "CM", value: "cm" },
                                      { label: "PX", value: "px" },
                                    ]}
                                    placeholderProp="Bottom"
                                    onSelect={handleUnitChange}
                                    handleInputChange={(e) =>
                                      setBottomValue(e.target.value)
                                    }
                                    inputVal={bottomValue}
                                    defaultOptionProp={unit}
                                  />
                                </Box>
                                <Box flex="1">
                                  <Flex align="center">
                                    <Input
                                      p='0'
                                      id="footer-color"
                                      type="color"
                                      border='none'
                                      value={footerColor}
                                      onChange={(e) => setFooterColor(e.target.value)}
                                      w="12"
                                      h="12"
                                      cursor="pointer"
                                    />
                                    <Input
                                      value={footerColor}
                                      onChange={(e) => setFooterColor(e.target.value)}
                                      placeholder="#000000"
                                      fontFamily="mono"
                                    />
                                  </Flex>
                                </Box>
                              </Flex>
                            </Box>

                            <PrimaryButton
                              mt="1rem"
                              buttonText="Save"
                              onClick={handleSave}
                            />
                          </VStack>
                        </Box>
                      </Flex>
                    </Box>
                  </>
                ) : (
            <>
              <Image
                src={options.find((opt) => opt.value === selectedTemplate)?.image}
                alt="Default Template"
                borderRadius="md"
                w="100%"
              />
              <PrimaryButton mt="1rem" buttonText="Save Default" onClick={handleSave} />
            </>
          )}
        </Stack>
      </Box>
      </>
    )}
    </>
  );
};

export default PrescriptionTemplates;
